export const sale = {
  TITLE: 'order_confirmation_page.sale_title',
  ORDERNUMBER: 'order_confirmation_order_number',
  ITEM_COUNT: 'order_confirmation_page.sale_item_count',
  QTY: 'order_confirmation_page.sale_quantity',
  ADDON_QTY: 'order_confirmation_page.sale_addon_quantity',
  PRICE: 'order_confirmation_page.sale_price',
  SUMMARY: 'order_confirmation_page.sale_summary',
  DELIVERY_FEE: 'order_confirmation_page.sale_delivery_fee',
  SHIPMENT_CHARGE: 'order_confirmation_page.sale_shipment_charge',
  SERVICE_FEE: 'order_confirmation_page.sale_service_fee',
  SUBTOTAL: 'order_confirmation_page.sale_subtotal',
  TOTAL: 'order_confirmation_page.sale_total',
  COUPON_CODE: 'order_confirmation_page.coupon_code',
  RECIPIENT: 'order_confirmation_page.recipient',
  TRANSACTION_ID: 'order_confirmation_page.venmo.transaction_id',
};
